import { Component, HostListener, OnInit } from '@angular/core';
import { AuthenticationService } from 'src/app/core';
import { DataService } from 'src/app/shared/services/data.service';

@Component({
  selector: 'app-sp-hmi-converter',
  templateUrl: './sp-hmi-converter.component.html',
  styleUrls: ['./sp-hmi-converter.component.scss']
})
export class SpHmiConverterComponent implements OnInit {
  isAdmin: string;
  appInfo;
  AppName: string;
  appId: number;
  constructor(private readonly dataService:  DataService, private readonly authenticationService: AuthenticationService) { }

  ngOnInit() {
    this.isAdmin = this.authenticationService.adminRole;
    this.dataService.getNewAppInfo().subscribe(info => {
      this.appInfo = info;
    })
    if (sessionStorage.getItem('appInfo')) {
      this.appInfo = JSON.parse(sessionStorage.getItem('appInfo'));
      sessionStorage.removeItem('appInfo');
    }
    this.AppName = this.appInfo.name;
    this.appId = this.appInfo.appId;
  }
 
  /*
    * Function to set Application info and  removes old info
    * 
  */
  @HostListener('window:beforeunload', ['$event'])
  unloadNotification(_$event) {
    sessionStorage.removeItem('appInfo');
    sessionStorage.setItem('appInfo', JSON.stringify(this.appInfo));
  }

}
